import { styled } from '@mui/material';
import { ComponentProps } from 'react';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { TOAST_Z_INDEX } from 'style/constants';

import { TOAST_DEFAULT_DURATION } from '../toast.constants';

export const StyledToastContainer = styled(ToastContainer)(({ theme }) => ({
  '&&&.Toastify__toast-container': {
    width: '400px',
    zIndex: TOAST_Z_INDEX,
  },
  '.Toastify__toast': {
    background: theme.palette.background.paper,
    boxShadow:
      '0px 8px 10px 0px #00000033, 0px 6px 30px 0px #0000001F, 0px 16px 24px 0px #00000024',
    borderRadius: '8px',
    padding: theme.spacing(5, 6, 5, 6),
    position: 'relative',
    '&:last-child': { marginBottom: '0px' },
  },
  '.Toastify__toast-body': {
    padding: '0px',
  },
  '.Toastify__progress-bar--wrp': {
    // If we use display: none, the toast will not automatically close
    height: '0px',
  },
}));

type IToastContainerProps = ComponentProps<typeof StyledToastContainer>;

const CustomToastContainer = (props: IToastContainerProps) => {
  return (
    <StyledToastContainer
      transition={Slide}
      hideProgressBar
      closeButton={false}
      autoClose={TOAST_DEFAULT_DURATION}
      {...props}
    />
  );
};

export default CustomToastContainer;
